import { render, staticRenderFns } from "./goodsCategorySelect.vue?vue&type=template&id=44a73ac0&"
import script from "./goodsCategorySelect.vue?vue&type=script&lang=js&"
export * from "./goodsCategorySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports